import React from 'react'
import { Row, Col } from 'react-bootstrap'
import Checkbox from './Checkbox'

const CheckboxListNoLabel = ({ list = [], text, className, name, values, onChange, style, required=false, disabled=false, ...props }) => {
  // const className = required ? "text-grey font-weight-bold medium required" : "text-grey font-weight-bold medium";
  const onListChange = (name, checked) => {
    onChange(name, checked)
  }

  return (
    <Row>
      <Col>
        <Row className="ml-1 my-2">
          <Col>
            {list.map((obj, index) => {
              return (
                <Checkbox className={className} key={index} to={text} name={obj.name} label={obj.label} onChange={onListChange} disabled={disabled} required={required} checked={props[obj.name]}/>
              )
            })}
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default CheckboxListNoLabel
